import apiAnalytic from '@/api/analytic'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null,
  total: null,
}

export const mutationTypes = {
  updateAnalyticStart: '[update analytic] Update analytic start',
  updateAnalyticSuccess: '[update analytic] Update analytic success',
  updateAnalyticFailure: '[update analytic] Update analytic failure',

  getAnalyticStart: '[update analytic] Get analytic start',
  getAnalyticSuccess: '[update analytic] Get analytic success',
  getAnalyticFailure: '[update analytic] Get analytic failure',
}

export const actionTypes = {
  updateAnalytic: '[update analytic] Update analytic',
  getAnalytic: '[update analytic] Get analytic',
}

const mutations = {
  [mutationTypes.updateAnalyticStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateAnalyticSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateAnalyticFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getAnalyticStart](state) {
    state.data = null
    state.isLoading = true
  },

  [mutationTypes.getAnalyticSuccess](state, payload) {
    state.data = payload
    state.total = payload.total | 0
    state.isLoading = false
  },

  [mutationTypes.getAnalyticFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.updateAnalytic](context, {id, analyticInput}) {
    context.commit(mutationTypes.updateAnalyticStart)
    return new Promise((resolve) => {
      apiAnalytic
        .updateAnalytic(id, analyticInput)
        .then((response) => {
          context.commit(mutationTypes.updateAnalyticSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.updateAnalyticFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getAnalytic](context, {type, id, params}) {
    context.commit(mutationTypes.getAnalyticStart)
    return new Promise((resolve) => {
      apiAnalytic
        .getAnalytic(type, id, params)
        .then((response) => {
          context.commit(mutationTypes.getAnalyticSuccess, response)
          resolve(response)
        })
        .catch(() => {
          context.commit(mutationTypes.getAnalyticFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
